const dbStateSelector = state => state.db;
export default dbStateSelector;